// extracted by mini-css-extract-plugin
export default {"header":"FVlUPDvo","logoWrap":"zKK2MLCB","logo":"cqEERH_B"};